import { createIcon } from './create-icon';

export const ChevronLeftIcon = createIcon('ChevronLeftIcon', <path d="M15 18l-6-6 6-6" />);
